module.exports = __webpack_public_path__ + "static/media/t-zew.04ff7ad6.svg";